<div class="btn-switch d-flex" *ngIf="isTableauView">
  <button class="btn button btn-green m-2 btn-width" style="width: 150px; font-size: 14px; padding: 0.13rem" (click)="onGoEcovadis()"> EcoVadis Link (sustainability score)
  </button>
  <button class="btn button btn-primary m-2 btn-width btn-vernova" (click)="onChangeSupplier(true)"
    [disabled]="checkDisabledRawTableau()"> Raw Data
  </button>
  <button class="btn button btn-primary m-2 btn-width mr-0 btn-vernova" (click)="downloadGuideLine()">Rating Guideline</button>
  <button class="btn button btn-primary m-2 btn-width mr-0 btn-vernova" *ngIf="type === UserType.INTERNAL_USER"
    (click)="backToTableau()">Internal View</button>
</div>
<div class="w-100 row mx-0 py-3" *ngIf="type==='supplier' || isTableauView">
  <div class="col-2 justify-content-center p-0" [ngStyle]="{'margin-top': isShowKperKpis ? '200px' : '0px'}">
    <div class="w-100">
      <span class="font-weight-bold ">Consider Parent Supplier</span>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select [(ngModel)]="considerParentSupplier">
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- <div class="w-100 mb-2" *ngIf="type===UserType.INTERNAL_USER">
      <span class="font-weight-bold ">Parent Supplier/GSL</span>
      <app-search-input [data]="listParentSupplierGSL" (result)="filterData('parentSupplier', $event)"
        (searchKey)="considerParentChange($event)" [values]="parentNameGSLs">
      </app-search-input>
    </div>
    <div class="w-100" *ngIf="type==='supplier'">
      <span class="font-weight-bold ">Parent Supplier/GSL</span>
      <app-multiple-select [data]="listParentSupplierGSL" (result)="filterData('parentSupplier', $event)"
        [defaultAll]="defaultALL">
      </app-multiple-select>
    </div> -->
    <div class="w-100">
      <span class="font-weight-bold ">Parent Company Name</span>
      <app-single-select [data]="parentNames" (result)="getGSL($event)" [values]="parents" [defaultAll]="defaultParent">
      </app-single-select>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Supplier Name/GSL</span>
      <app-lazyload-multiple-select [data]="gslNumbers" (result)="filterData('gslNumber', $event)" [defaultAll]="false"
        [values]="parentNameGSLs">
      </app-lazyload-multiple-select>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Time Range</span>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select [(ngModel)]="timeRange" (selectionChange)="timeRangeChanged()">
          <mat-option value="1">Year To Date</mat-option>
          <mat-option value="2">12 Months Rolling</mat-option>
          <mat-option value="3">Last 3 months</mat-option>
          <mat-option value="4">Month</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Ending PO Receipt Month</span>
      <mat-form-field appearance="outline" class="w-100">
        <input matInput [owlDateTimeTrigger]="dt" [owlDateTime]="dt" [formControl]="dateTime" [max]="currentDate"
          readonly style="cursor: pointer;">
        <owl-date-time [pickerType]="'calendar'" [startView]="'multi-years'" (yearSelected)="chosenYearHandler($event)"
          (monthSelected)="chosenMonthHandler($event, dt)" #dt="owlDateTime"></owl-date-time>
      </mat-form-field>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Commodity</span>
      <app-multiple-select [data]="listCommodity" [defaultAll]="defaultALL" (result)="filterData('commodity', $event)"
        [values]="commodities">
      </app-multiple-select>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">GE Location</span>
      <app-multiple-select [data]="listLocation" [defaultAll]="defaultALL" (result)="filterData('location', $event)"
        [values]="locations">
      </app-multiple-select>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Region</span>
      <app-multiple-select [data]="listRegion" [defaultAll]="defaultALL" (result)="filterData('region', $event)"
        [values]="regions">
      </app-multiple-select>
    </div>
    <div class="w-100 d-flex align-items-center justify-content-center">
      <button class="btn btn-add button btn-primary btn-vernova" (click)="onApplyClick()"
        [disabled]="checkDisabled()">APPLY</button>
    </div>

  </div>
  <div class="col-10 pr-0">
    <div class="col-12 row info-gsl m-0 p-0">
      <div class="col-3 d-flex justify-content-between p-0 bg-color">
        <mat-form-field appearance="outline" class="w-100 align-items-center justify-content-center">
          <mat-select [(ngModel)]="parentNameModel" name="name" (selectionChange)="onChangeSupplier()">
            <mat-option *ngFor="let item of listParentName; let i = index;" [value]="i">
              <span>{{item.name}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-9 row info-scorecard ml-0">
        <div class="total-spend col-4 d-flex flex-column align-items-center p-2">
          <div class="w-200 h-100 d-flex flex-column scoll h-140">
            <span class="w-200 h-140 item font-weight-bold"
            style="word-break: break-word; word-wrap: break-word; font-size: 1.5em !important;">{{totalSpend}}</span>
          </div>
          <span class="text w-200 h-30 item text-center" style="align-items: flex-end; color: #C8FF08 !important;">Period Spend</span>
        </div>
        <!-- <div class="col-2 total-spend d-flex flex-column align-items-center p-2">
          <span class="w-100 h-70 item font-weight-bold">{{listScorecardInfo?.hpdnd}}%</span>
          <span class="text w-100 h-30 item text-center" style="align-items: flex-end;">Promised Date vs Need By
            Date</span>
        </div> -->
        <!-- <div class="col-2 total-spend d-flex flex-column align-items-center p-2">
          <span class="w-100 h-70 item font-weight-bold">{{listScorecardInfo?.hpdm}}%</span>
          <span class="text w-100 h-30 item text-center" style="align-items: flex-end;">Missing Promised Date %</span>
        </div> -->
        <div class="col-4 total-spend d-flex flex-column align-items-center p-2">
          <div class="w-200 h-100 d-flex flex-column scoll h-140">
            <span *ngFor="let item of listScorecardInfo?.commodities"
              class="w-200 text-white item value-size">{{item}}</span>
          </div>
          <span class="text w-200 item text-white h-30" style="align-items: flex-end; color: #C8FF08 !important;">Commodities</span>
        </div>
        <div class="col-4 total-spend d-flex flex-column align-items-center p-2">
          <div class="w-200 h-100 d-flex flex-column scoll h-140">
            <span *ngFor="let item of listScorecardInfo?.geLocations"
              class="w-200 text-white item value-size">{{item}}</span>
          </div>
          <span class="text w-100 item text-white h-30" style="align-items: flex-end; color: #C8FF08 !important;">GE Locations</span>
        </div>
        <!-- <div class="col-2 total-spend d-flex flex-column align-items-center p-2">
          <div class="w-100 h-100 d-flex flex-column scoll h-70">
            <span *ngFor="let item of listScorecardInfo?.regions"
              class="w-100 text-white item value-size">{{item}}</span>
          </div>
          <span class="text w-100 item text-white h-30" style="align-items: flex-end;">Regions</span>
        </div> -->
      </div>
    </div>
    <h3 class="" style="margin-top: 0.5rem !important; background-color: #FAFAFA; font-size: 36px; color: #005E60; padding-left: 10px;">PERFORMANCE</h3>
    <div class="col-12 row mt-3 mx-0 p-0">
      <div class="col-lg-3 col-md-6 col-12 p-0">
        <div class="performance p-0">
          <div class="title">
            <span class="firstChar">S</span>
            <span class="titleKpiGroup">ustainability</span>
          </div>
          <div class="col-12 p-0">
            <div class="col-12 row m-0 p-0">
              <div class="my-2 pl-0" *ngFor="let item of performanceSustainData; let isFirst = first"
              [ngStyle]="{'display': (isFirst || isShowKperKpis) ? 'block' : 'none', 'min-height': '70px'}"  [ngClass]="isFirst ? 'col-12 bg-grey-3' : 'col-6'">
              <div class="col-12 row m-0 p-0 justify-content-between">
                <div class="col-12 row m-0 p-0 mb-3 name" [ngStyle]="{ 'text-align': isFirst ? '' : 'center', 'min-height': isFirst ? '' : '50px' }">
                  <span class="mainName">{{item.title}}{{item.test}}</span>
                  <span style="font-style: italic;" *ngIf="item.subTitle">{{item.subTitle}}</span>
                </div>
                <div class="col-12 row m-0 p-0" *ngIf="isFirst">
                  <div class="col-2"></div>
                  <div class="col-9" *ngFor="let i of grids">
                    <div class="d-flex justify-content-between text-center w-100">
                      <span class="header-title italic">Score</span>
                      <span class="header-title italic">Trend</span>
                    </div>
                  </div>
                  <div class="col-1"></div>
                </div>
                <div class="d-flex flex-column pl-2" style="padding: 0 0.5rem;" [ngStyle]="{'width': isFirst ? '50%' : '100%'}">
                  <div class="justify-content-between w-100 h-100 align-items-center" [class]="isFirst ? 'd-flex' : ''">
                    <span *ngIf="isFirst">
                      <span class="w-50 text-center font-value" *ngIf="item.gaugeData">
                        <app-gauge-chart [value]="item.gaugeData.v" [min]="item.gaugeData.n" [max]="item.gaugeData.m" [data]="item.gaugeData" [page]="'ExternalPage'"></app-gauge-chart>
                      </span>                  
                    </span>
                    <span *ngIf="!isFirst">
                      <div class="w-100 d-flex justify-content-center">
                        <div class="white-box">{{ item.v }}</div>
                          <!-- <app-progress-bar [width]="item.v" [isValue]="true" class="w-100" [unit]="item.unit" [color]="item.clr"></app-progress-bar> -->
                      </div>
                    </span>
                  </div>
                </div>
                <div style="width: 40%; padding: 0 0.5rem;" *ngIf="item.trend && isFirst">
                  <app-trend-chart *ngIf="isShowKperKpis || isFirst" [data]="item.trend" [name]="item.title" [gsl]="item.gsl"></app-trend-chart>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12 p-0">
        <div class="performance p-0">
          <div class="title">
            <span class="firstChar">Q</span>
            <span class="titleKpiGroup">uality</span>
          </div>
          <div class="col-12 p-0">
            <div class="col-12 row m-0 p-0">
              <div class="col-12 my-2 pl-0" *ngFor="let item of performanceQualityData; let isFirst = first; let isLast = last"
              [ngStyle]="{'display': (isFirst || isShowKperKpis) ? 'block' : 'none', 'min-height': '70px'}"  [ngClass]="isFirst ? 'bg-grey-3' : !isLast ? 'br-grey-3' : ''">
                <div class="col-12 row m-0 p-0 justify-content-between">
                  <div class="col-12 row m-0 p-0 mb-3 name">
                    <span class="mainName">{{item.title}}{{item.test}}</span>
                    <span style="font-style: italic;" *ngIf="item.subTitle">{{item.subTitle}}</span>
                  </div>
                  <div class="col-12 row m-0 p-0" *ngIf="!isLast">
                    <div class="col-2"></div>
                    <div class="col-9" *ngFor="let i of grids">
                      <div class="d-flex justify-content-between text-center w-100">
                        <span class="header-title italic">Score</span>
                        <span class="header-title italic">Trend</span>
                      </div>
                    </div>
                    <div class="col-1"></div>
                  </div>
                  <div class="d-flex flex-column pl-2" [ngStyle]="{'width': isLast ? '100%' : '50%'}">
                    <div class="justify-content-between w-100 h-100 align-items-center" [class]="isFirst ? 'd-flex' : ''">
                      <span *ngIf="isFirst && !isLast">
                        <span class="w-50 text-center font-value" *ngIf="item.gaugeData">
                          <app-gauge-chart [value]="item.gaugeData.v" [min]="item.gaugeData.n" [max]="item.gaugeData.m" [data]="item.gaugeData" [page]="'ExternalPage'"></app-gauge-chart>
                        </span>                  
                      </span>
                      <span *ngIf="!isFirst && !isLast">
                        <span class="w-50 text-center font-value" style="padding-left: 18%;" *ngIf="item.unit">{{item.n +
                          item.unit}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 23%;"
                          *ngIf="!item.unit">{{item.n}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 40%;" *ngIf="item.unit">{{item.m +
                          item.unit}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 40%;"
                          *ngIf="!item.unit">{{item.m}}</span>
                        <div class="w-100 d-flex justify-content-center">
                            <app-progress-bar [width]="item.v" [isValue]="true" class="w-100" [unit]="item.unit"
                              [color]="item.clr"></app-progress-bar>
                        </div>
                      </span>
                      <span *ngIf="isLast">
                        <div class="w-100 d-flex justify-content-center">
                          <div [ngSwitch]="item.clr">
                            <ng-container *ngSwitchCase="'red'">
                              <!-- Render an image if item.clr is 'red' -->
                              <img src="../../../../assets/images/disrupted.jpg" alt="" style="width: 50px;">
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                              <img src="../../../../assets/images/no_disrupt.jpg" alt="" style="width: 50px;">
                            </ng-container>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div style="width: 40%; padding: 0 0.5rem;" *ngIf="item.trend && !isLast">
                    <app-trend-chart *ngIf="isShowKperKpis || isFirst" [data]="item.trend" [name]="item.title" [gsl]="item.gsl"></app-trend-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12 p-0">
        <div class="performance p-0">
          <div class="title">
            <span class="firstChar">D</span>
            <span class="titleKpiGroup">elivery</span>
          </div>
          <div class="col-12 p-0">
            <div class="col-12 row m-0 p-0">
              <div class="col-12 my-2 pl-0" *ngFor="let item of performanceDeliveryData; let isFirst = first; let isLast = last"
              [ngStyle]="{'display': (isFirst || isShowKperKpis) ? 'block' : 'none', 'min-height': '70px'}"  [ngClass]="isFirst ? 'bg-grey-3' : 'br-grey-3'">
                <div class="col-12 row m-0 p-0 justify-content-between">
                  <div class="col-12 row m-0 p-0 mb-3 name">
                    <span class="mainName">{{item.title}}{{item.test}}</span>
                    <span style="font-style: italic;" *ngIf="item.subTitle">{{item.subTitle}}</span>
                  </div>
                  <div class="col-12 row m-0 p-0">
                    <div class="col-2"></div>
                    <div class="col-9" *ngFor="let i of grids">
                      <div class="d-flex justify-content-between text-center w-100">
                        <span class="header-title italic">Score</span>
                        <span class="header-title italic">Trend</span>
                      </div>
                    </div>
                    <div class="col-1"></div>
                  </div>
                  <div class="d-flex flex-column pl-2" style="width: 50%;">
                    <div class="justify-content-between w-100 h-100 align-items-center" [class]="isFirst ? 'd-flex' : ''">
                      <span *ngIf="isFirst">
                        <span class="w-50 text-center font-value" *ngIf="item.gaugeData">
                          <app-gauge-chart [value]="item.gaugeData.v" [min]="item.gaugeData.n" [max]="item.gaugeData.m" [data]="item.gaugeData" [page]="'ExternalPage'"></app-gauge-chart>
                        </span>                  
                      </span>
                      <span *ngIf="!isFirst">
                        <span class="w-50 text-center font-value" style="padding-left: 18%;" *ngIf="item.unit">{{item.n +
                          item.unit}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 23%;"
                          *ngIf="!item.unit">{{item.n}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 40%;" *ngIf="item.unit">{{item.m +
                          item.unit}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 40%;"
                          *ngIf="!item.unit">{{item.m}}</span>
                        <div class="w-100 d-flex justify-content-center">
                            <app-progress-bar [width]="item.v" [isValue]="true" class="w-100" [unit]="item.unit"
                              [color]="item.clr"></app-progress-bar>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div style="width: 40%; padding: 0 0.5rem;" *ngIf="item.trend">
                    <app-trend-chart *ngIf="isShowKperKpis || isFirst" [data]="item.trend" [name]="item.title" [gsl]="item.gsl"></app-trend-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12 p-0">
        <div class="performance p-0">
          <div class="title">
            <span class="firstChar">C</span>
            <span class="titleKpiGroup">ost</span>
          </div>
          <div class="col-12 p-0">
            <div class="col-12 row m-0 p-0">
              <div class="col-12 my-2 pl-0" *ngFor="let item of performanceCostData; let isFirst = first; let isLast = last"
                [ngStyle]="{'display': (isFirst || isShowKperKpis) ? 'block' : 'none', 'min-height': '70px'}"  [ngClass]="isFirst ? 'bg-grey-3' : 'br-grey-3'">
                <div class="col-12 row m-0 p-0 justify-content-between">
                  <div class="col-12 row m-0 p-0 mb-3 name">
                    <span class="mainName">{{item.title}}{{item.test}}</span>
                    <span style="font-style: italic;" *ngIf="item.subTitle">{{item.subTitle}}</span>
                  </div>
                  <div class="col-12 row m-0 p-0">
                    <div class="col-2"></div>
                    <div class="col-9" *ngFor="let i of grids">
                      <div class="d-flex justify-content-between text-center w-100">
                        <span class="header-title italic">Score</span>
                        <span class="header-title italic">Trend</span>
                      </div>
                    </div>
                    <div class="col-1"></div>
                  </div>
                  <div class="d-flex flex-column pl-2" style="width: 50%;">
                    <div class="justify-content-between w-100 h-100 align-items-center" [class]="isFirst ? 'd-flex' : ''">
                      <span *ngIf="isFirst">
                        <span class="w-50 text-center font-value" *ngIf="item.gaugeData">
                          <app-gauge-chart [value]="item.gaugeData.v" [min]="item.gaugeData.n" [max]="item.gaugeData.m" [data]="item.gaugeData" [page]="'ExternalPage'"></app-gauge-chart>
                        </span>                  
                      </span>
                      <span *ngIf="!isFirst">
                        <span class="w-50 text-center font-value" style="padding-left: 5%;" *ngIf="item.unit">{{item.n +
                          item.unit}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 23%;"
                          *ngIf="!item.unit">{{item.n}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 15%;" *ngIf="item.unit">{{item.m +
                          item.unit}}</span>
                        <span class="w-50 text-center font-value" style="padding-left: 40%;"
                          *ngIf="!item.unit">{{item.m}}</span>
                        <div class="w-100 d-flex justify-content-center">
                            <app-progress-bar [width]="item.v" [isValue]="true" class="w-100" [unit]="item.unit"
                              [color]="item.clr"></app-progress-bar>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div style="width: 40%; padding: 0 0.5rem;" *ngIf="item.trend">
                    <app-trend-chart *ngIf="isShowKperKpis || isFirst" [data]="item.trend" [name]="item.title" [gsl]="item.gsl"></app-trend-chart>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <p (click)="showHidePerfKpi()" class="btn-showhide">
                  <i class="fa pr-2" [ngClass]="{'fa-eye-slash': isShowKperKpis, 'fa-eye': !isShowKperKpis}" style="color: #005e60;"></i>
                  <span>{{ isShowKperKpis ? 'Hide Details' : 'Show Details' }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3 class="" style="margin-top: 0.5rem !important; background-color: #FAFAFA; font-size: 36px; color: #005E60; padding-left: 10px;">BEHAVIORS</h3>
    <div class="col-12 row mt-3 mx-0 p-0">
      <div class="col-lg-3 col-md-6 col-12 p-0" *ngFor="let item of relationshipData; let isLast = last">
        <div class="performance p-0">
          <div class="col-12 p-0">
            <div class="col-12 row m-0 p-0">
              <div class="col-12 mb-2 pl-0" style="min-height: 70px;">
                <div class="col-12 row m-0 p-0">
                  <div class="col-12 row m-0 mb-4 p-0 name title" style="justify-content: left !important;">
                    <!-- <span class="mainName titleKpiGroup">{{item.title}}</span> -->
                    <span class="mainName">
                      <span class="firstChar">{{ item.title.charAt(0) }}</span>
                      <span class="titleKpiGroup">{{ item.title.substring(1) }}</span>
                    </span>
                    <span style="font-style: italic;" *ngIf="item.subTitle">{{item.subTitle}}</span>
                  </div>
                  <div class="d-flex flex-column pl-2" style="width: 50%; margin-left: 25%;">
                    <div class="justify-content-between w-100 h-100 align-items-center">
                      <span>
                        <span class="w-50 text-center font-value" *ngIf="item.gaugeData">
                          <app-gauge-chart [value]="item.gaugeData.v" [min]="item.gaugeData.n" [max]="item.gaugeData.m" [data]="item.gaugeData" [page]="'ExternalPage'"></app-gauge-chart>
                        </span>                  
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end font-weight-bold mb-2">
      <span>Last Refresh Date: {{lastUpdate}}</span>
    </div>
    <!-- <div class="col-12 mt-3 mx-0 p-0 segmentation" *ngIf="type=== UserType.IN">
      <div class="w-100 p-3">
        <span class="title">Segmentation</span>
        <div class="d-flex flex-column ">
          <table class="w-70">
            <tr>
              <th class="w-20"></th>
              <th class="w-40"></th>
              <th class="w-30 d-flex align-items-center justify-content-center">Max Score</th>
            </tr>
            <tr *ngFor="let item of segmentation" class="mt-2">
              <td class="py-2 font-weight-bold">{{item.title}}</td>
              <td>
                <app-progress-bar-v2 [value]="item.value" [max]="item.maxScore ? item.maxScore.value : 100"
                  class="w-100"></app-progress-bar-v2>
              </td>
              <td class="w-30 py-2 font-weight-bold pl-3">{{item.maxScore ? item.maxScore.value : ''}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div> -->
  </div>
</div>

<!-- Table View -->
<div class="w-100 mx-0 py -0" *ngIf="type === UserType.INTERNAL_USER && !isTableauView">
  <div class="d-flex justify-content-between">
    <div class="d-flex">
      <button class="btn button btn-primary ml-0 m-2 btn-width btn-vernova" (click)="openDialogFilter()">Filter
        <span *ngIf="totalResults !== 0" class="result">({{totalResults}}
          results)</span>
      </button>
      <button class="btn button btn-primary m-2 btn-width ml-0 btn-vernova" (click)="exportExcel()">Export</button>
    </div>
    <div class="d-flex">
      <ul class="m-2 align-items-center menu-button btn-width" style="border: 1px solid #005E60; border-radius: 3px; color: #005E60; min-width: 75px;">
        Reports <span class="material-icons">
          view_headline
        </span>
        <div class="list-button">
          <li *ngFor="let item of buttonInternalView" (click)="item.method()"> {{ item.name }}</li>
        </div>
      </ul>
      <button class="btn button btn-primary m-2 btn-width button-function" *ngFor="let item of buttonInternalView"
        (click)="item.method()">
        {{ item.name }}
      </button>
      <button class="btn button btn-green m-2 btn-width btn-vernova" style="width: 150px; font-size: 14px; padding: 0.13rem" (click)="onGoEcovadis()"> EcoVadis Link (sustainability score)
      </button>
      <button class="btn button btn-primary m-2 btn-width mr-0 btn-vernova" (click)="showLegend()">Show Legend</button>
      <button class="btn button btn-primary m-2 btn-width mr-0 btn-vernova" (click)="downloadGuideLine()">Rating Guideline</button>
      <!-- <div class="otd btn button btn-primary m-2 btn-width">
        <span class="h-100 d-flex justify-content-center align-items-center">OTD</span>
        <div class="menu">
          <span (click)="downloadOTDPromisedDate()">OTD Promised date</span>
          <span (click)="downloadOTDNeeds()">OTD Needs</span>
        </div>
      </div> -->
      <button class="btn button btn-primary m-2 btn-width mr-0 btn-vernova" (click)="backToTableau()">Supplier View</button>
    </div>
  </div>
  <div class="mt-3 w-100 scroll-table mb-2">
    <table mat-table [dataSource]="dataSource" class="w-100 table mb-0" matSort (matSortChange)="sortHeader($event)"
      #table>

      <!-- Header row first group -->
      <ng-container matColumnDef="header-row-first-group">
        <th mat-header-cell *matHeaderCellDef 
            [style.text-align]="center"
            [attr.colspan]="getTblHeaderPlaceHolderLeft()" style="opacity: 0;"> 
          
        </th>
      </ng-container>
      <ng-container matColumnDef="header-row-sec-group">
        <th mat-header-cell *matHeaderCellDef 
            [style.text-align]="center"
            [attr.colspan]="getTblHeaderPlaceHolderKPI()">
            <div class="header-group font-extrabold">
              KPIs
            </div>
        </th>
      </ng-container>s
      <ng-container matColumnDef="header-row-third-group">
        <th mat-header-cell *matHeaderCellDef 
            [style.text-align]="center"
            [attr.colspan]="getTblHeaderPlaceHolderScoreSegment()"
            (click)="showHideScoreSegmentGroup()" style="min-width: 150px;">
          <div class="header-group-normal" [ngClass]="{'header-group': isShowScoreSegmentGroup}" style="cursor: pointer;">
            {{ isShowScoreSegmentGroup ? 'Scoring & Segmentation' : '(Show Details for Scoring & Segmentation)' }}
          </div>
        </th>
      </ng-container>

      <!-- Dynamic Column -->
      <ng-container matColumnDef="{{item.displayedColumns}}"
        [sticky]="item.displayedColumns==='parentCompany' || item.displayedColumns==='supplierName'"
        *ngFor="let item of tableSettings; let first = first; let last = last">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!item.sortHeader"
          [style.min-width]="item.minWidth ? item.minWidth : ''" [style.width]="item.width ? item.width : ''">
          <div class="header">
            {{item.header}}
            <span *ngIf="item.subHeader">{{item.subHeader}}</span>
            <span *ngIf="item.content && item.showDetail" style="font-style: italic;">{{item.content}}</span>
            <span *ngIf="item.displayedColumns === 'totalScore'" style="font-size: 0.9rem;">{{totalScore}}</span>
          </div>
          <div class="details">
            <button *ngIf="item.hasShowDetails" (click)="showHideDetail(item.displayedColumns, !item.showDetail)"
              class="btn-details">{{item.showDetail ? 'Hide Details' : 'Show Details'}}</button>
          </div>
        </th>
        <!-- row span 2 cases: consider = yes: consilidate fields: parent, commercialClassGap, segmentClass, commercialClass -->
        <td mat-cell *matCellDef="let element"
          [attr.rowSpan]="checkRowSpan(item.field, resultFilter.value.considerSupplierCommodity, element.rowSpanParent, element.rowSpanSupplier)"
          [style.display]="checkRowSpan(item.field, resultFilter.value.considerSupplierCommodity, element.rowSpanParent,  element.rowSpanSupplier) === 0 ? 'none'  : ''"
          [ngClass]="element[item.field]?.clr + (!element['supplierName'] ? ' font-weight-bold' : '')">
          <div class="w-100 h-100 d-flex justify-content-center">
            <button
              *ngIf="item.field === 'supplierName' && !element[item.field] && isBoolean(element['isShow']) && resultFilter.value.parents.length > 0 && !resultFilter.value.considerSupplierCommodity"
              class="btn-details" (click)="hideChildren(!element.isShow, element.parentCompany)">
              {{element.isShow ? 'Hide Details' : 'Show Details'}}
            </button>
          </div>
          <span [ngClass]="item.field === 'parentCompany' || item.field === 'supplierName' || item.field === 'commodity' ? 'value-left' : 'value'" *ngIf="item.field !== 'supplierName'"
            [style.cursor]="item.field === 'ytdCostOutSupplierDeflation' || item.field === 'ytdSupplierDeflation' ? 'pointer' : 'unset'"
            (click)="downloadSupplierPrice(element, item.field)">
            {{initValueTable(element, item.field)}}{{isNumber(initValueTable(element, item.field)) && item.unit ?
            item.unit : ''}}
          </span>
          <span class="value pl-1 justify-content-start" *ngIf="item.field === 'supplierName' && element[item.field]">
            {{element.supplierName}}
          </span>
          <span class="material-icons icon d-flex justify-content-center"
            *ngIf="item.hasTrendingChart && isNumber(initValueTable(element, item.field))"
            (click)="openTrendingChart(item.header, element[item.field]?.trend, element['supplierName'] ? element['supplierName'] : element['parentCompany'], element['gslNumber'])"
            [ngClass]="element[item.field]?.trend?.p ? 'icon-blue' : 'icon-red'">
            trending_up
          </span>
          <div *ngIf="item.hasInforCostout && isNumber(initValueTable(element, item.field))" class="info-target">
            <span class="material-icons icon info justify-content-center" style="font-size: 18px;" >
            </span>
            <div class="d-none target">
              <span class="title">Target</span>
              <hr class="m-0">
              <div class="kpi d-flex justify-content-between">
                <span class="green w-100 p-1"> {{ CONDITION[element[item.field]?.exceedOp] }} {{  element[item.field]?.mx }}{{ item.unit ? item.unit : '' }}</span>
                <span class="orange w-100 p-1">{{ element[item.field]?.mx }} {{ item.unit ? item.unit : '' }} {{ getOperator(element[item.field])}} {{ element[item.field]?.mn }}{{ item.unit ? item.unit : '' }}</span>
                <span class="red w-100 p-1">{{CONDITION[element[item.field]?.belowOp] }} {{ element[item.field]?.mn }}{{ item.unit ? item.unit : '' }}</span>
              </div>
            </div>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['header-row-first-group','header-row-sec-group','header-row-third-group']"></tr>
      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
    </table>
  </div>
  <div class="d-flex justify-content-end font-weight-bold mb-2">
    <span>Last Refresh Date: {{lastUpdate}}</span>
  </div>
  <app-ngx-mat-paginator class="w-100" *ngIf="!!dataSource && dataSource.data.length > 0"
    [requestOption]="requestOption" (requestOptionChange)="onChangeRequestOption($event)"></app-ngx-mat-paginator>
</div>